// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `small {
  font-size: 13px;
  padding-left: 1px;
  position: absolute;
  z-index: 99;
  color: #DC3545;
}

.icon-error {
  position: relative;
  z-index: 99;
  width: auto;
  bottom: 38px;
  margin-top: 0;
  float: right;
  margin-right: 8px;
  color: #DC3545;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlucHV0LWVycm9yLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksZUFBQTtFQUNBLGlCQUFBO0VBQ0Esa0JBQUE7RUFDQSxXQUFBO0VBQ0EsY0FBQTtBQUNKOztBQUVBO0VBQ0ksa0JBQUE7RUFDQSxXQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7RUFDQSxhQUFBO0VBQ0EsWUFBQTtFQUNBLGlCQUFBO0VBQ0EsY0FBQTtBQUNKIiwiZmlsZSI6ImlucHV0LWVycm9yLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsic21hbGwge1xuICAgIGZvbnQtc2l6ZTogMTNweDtcbiAgICBwYWRkaW5nLWxlZnQ6IDFweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgei1pbmRleDogOTk7XG4gICAgY29sb3I6ICNEQzM1NDU7XG59XG5cbi5pY29uLWVycm9yIHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgei1pbmRleDogOTk7XG4gICAgd2lkdGg6IGF1dG87XG4gICAgYm90dG9tOiAzOHB4O1xuICAgIG1hcmdpbi10b3A6IDA7XG4gICAgZmxvYXQ6IHJpZ2h0O1xuICAgIG1hcmdpbi1yaWdodDogOHB4O1xuICAgIGNvbG9yOiAjREMzNTQ1O1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/core/components/input-error/input-error.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AACJ;AACA,g1BAAg1B","sourcesContent":["small {\n    font-size: 13px;\n    padding-left: 1px;\n    position: absolute;\n    z-index: 99;\n    color: #DC3545;\n}\n\n.icon-error {\n    position: relative;\n    z-index: 99;\n    width: auto;\n    bottom: 38px;\n    margin-top: 0;\n    float: right;\n    margin-right: 8px;\n    color: #DC3545;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
